import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Amour',
    description: 'A decade of studio portraiture, assembled into one shape.',
    url: getOrigin()
}